<template>
    <div class="batteryVoltage">
        <a      class="plain-link"
                :href="batteryLink">
            <span :class="batteryClass"
                  :title="batteryTitle">
            </span>
        </a>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
    name: "BatteryPercentIcon",
    mixins: [SonicuCoreMixin],
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
        batteryPercent: {
            type: Number,
            required: true,
        },
        powerOk: {
            type: [String, Boolean],
            required: true,
        },
        companyId: {
            type: String,
            required: false,
        },
    },
    computed: {
        batteryClass: function(){
            if (this.power) {
                if (this.batteryPercent === 0){
                    return 'lnr icon-battery-charging text-red-700';
                } else if (this.batteryPercent < 20) {
                    return 'lnr icon-battery-charging2 text-red-700';
                } else if (this.batteryPercent < 40) {
                    return 'lnr icon-battery-charging3 text-yellow-400';
                } else if (this.batteryPercent < 60) {
                    return 'lnr icon-battery-charging4 text-yellow-400';
                } else if (this.batteryPercent < 80) {
                    return 'lnr icon-battery-charging5 text-green-600';
                } else if (this.batteryPercent < 100) {
                    return 'lnr icon-battery-charging6 text-green-600';
                } else {
                    return 'lnr icon-battery-charging7 text-green-600';
                }
            } else {
                if (this.batteryPercent === 0) {
                    return 'lnr icon-battery-low1 text-red-600';
                } else if (this.batteryPercent < 20) {
                    return 'lnr icon-battery-low2 text-red-600';
                } else if (this.batteryPercent < 40) {
                    return 'lnr icon-battery-low3 text-yellow-400';
                } else if (this.batteryPercent < 60) {
                    return 'lnr icon-battery-mid1 text-yellow-400';
                } else if (this.batteryPercent < 80) {
                    return 'lnr icon-battery-mid2 text-green-600';
                } else if (this.batteryPercent < 100) {
                    return 'lnr icon-battery-mid3 text-green-600';
                } else {
                    return 'lnr icon-battery-full text-green-600';
                }
            }
        },
        power() {
            return Boolean(this.powerOk)
        },
        batteryTitle: function() {
            let title = 'Battery Charge:' + this.batteryPercent + '%';
            if (this.power){
                title += ' (Charging)';
            }
            return title;
        },
        batteryLink: function() {
            return this.company.buildCompanyRoute(`meters/${this.id}`)
        }
    }
}
</script>

<style scoped>
    .batteryVoltage {
        display: inline;
        margin: auto;
        float: right;
    }
</style>